import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { ActionIcon } from "../../action-icon";
import { AutoMenu, AutoMenuWithPlainItemsProps } from "../../auto-menu";
import { Icon } from "../../icon";

/**
 * Add a button to add more filters to the dynamic filter menu.
 * @param props - Props to pass to the AutoMenu component.
 * @returns A button to add more filters.
 */
export const AddMoreFiltersButton = <Item,>(props: Omit<AutoMenuWithPlainItemsProps<Item>, "children">) => {
    return (
        <AutoMenu.WithPlainItems searchable {...props}>
            <ActionIcon variant="default" size="input-sm" data-testid="add-more-filters-button">
                <Icon icon={faPlus} />
            </ActionIcon>
        </AutoMenu.WithPlainItems>
    );
};
